import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import { getLanguageFromUrl } from 'shared/helpers/parseUrl';
import { Key } from 'i18n/Key';

import en from 'i18n/translations/en.json';
import fr from 'i18n/translations/fr.json';
import ro from 'i18n/translations/ro.json';
import de from 'i18n/translations/de.json';
import sv from 'i18n/translations/sv.json';
import hr from 'i18n/translations/hr.json';
import es from 'i18n/translations/es.json';
import ru from 'i18n/translations/ru.json';
import it from 'i18n/translations/it.json';
import da from 'i18n/translations/da.json';
import lt from 'i18n/translations/lt.json';
import bg from 'i18n/translations/bg.json';
import id from 'i18n/translations/id.json';
import ja from 'i18n/translations/ja.json';
import ko from 'i18n/translations/ko.json';
import nl from 'i18n/translations/nl.json';
import th from 'i18n/translations/th.json';
import vi from 'i18n/translations/vi.json';
import zh from 'i18n/translations/zh.json';
import lv from 'i18n/translations/lv.json';

export const DEFAULT_NS = 'translation';
export const DEFAULT_LANG = 'en';

const resources = {
  en: {
    [DEFAULT_NS]: en,
  },
  fr: {
    [DEFAULT_NS]: fr,
  },
  ro: {
    [DEFAULT_NS]: ro,
  },
  de: {
    [DEFAULT_NS]: de,
  },
  sv: {
    [DEFAULT_NS]: sv,
  },
  hr: {
    [DEFAULT_NS]: hr,
  },
  es: {
    [DEFAULT_NS]: es,
  },
  ru: {
    [DEFAULT_NS]: ru,
  },
  it: {
    [DEFAULT_NS]: it,
  },
  da: {
    [DEFAULT_NS]: da,
  },
  lt: {
    [DEFAULT_NS]: lt,
  },
  bg: {
    [DEFAULT_NS]: bg,
  },
  id: {
    [DEFAULT_NS]: id,
  },
  ja: {
    [DEFAULT_NS]: ja,
  },
  ko: {
    [DEFAULT_NS]: ko,
  },
  nl: {
    [DEFAULT_NS]: nl,
  },
  th: {
    [DEFAULT_NS]: th,
  },
  vi: {
    [DEFAULT_NS]: vi,
  },
  zh: {
    [DEFAULT_NS]: zh,
  },
  lv: {
    [DEFAULT_NS]: lv,
  },
};

i18n.use(initReactI18next).init({
  resources: resources,
  lng: getLanguageFromUrl(),
  fallbackLng: DEFAULT_LANG,
  interpolation: {
    escapeValue: false,
  },
});

export const addDefaultTranslates = (
  trans: { [key in keyof typeof Key]?: string },
) => {
  const defaultTrans = i18n.getResourceBundle(DEFAULT_LANG, DEFAULT_NS);
  Object.entries(trans).forEach(([key, img]) => {
    if (!defaultTrans[img])
      i18n.addResources(DEFAULT_LANG, DEFAULT_NS, { [key]: img });
  });
};
